// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__20H2g","legacyBtn":"MutateMid_legacyBtn__HsrSY"};